import React from 'react';
import { PublicPage, PublicCard } from '../PublicPage';
import {
  CORPORATE_PROFILE,
  GOVERNMENT_RECOGNITION,
  GOVERNMENT_RECOGNITION_INTRO,
  CORPORATE_PROFILE_TAIL,
  BUSINESS_ACTIVITY_INTRO,
  BUSINESS_ACTIVITY_POINTS,
  BUSINESS_ACTIVITY_TAIL,
  MISSION,
  VISION,
  PRODUCTS_INTRO,
  PRODUCTS_POINTS,
  PRODUCTS_TAIL,
  BOARD_INTRO,
  BOARD_MEMBERS,
} from './aboutUsContent';

const paras = (items: string[]) => items.map((t) => <p key={t}>{t}</p>);
const bullets = (items: string[]) => (
  <ul>
    {items.map((t) => (
      <li key={t}>{t}</li>
    ))}
  </ul>
);

export const AboutUs: React.FC = () => (
  <PublicPage
    title="About Us"
    subtitle="Who Facilon is, what we do, and the people behind it."
    icon="bi-building"
  >
    <PublicCard title="Our Corporate Profile" icon="bi-file-earmark-text">
      <div className="page-prose">
        {paras(CORPORATE_PROFILE)}
        <p>{GOVERNMENT_RECOGNITION_INTRO}</p>
        {bullets(GOVERNMENT_RECOGNITION)}
        {paras(CORPORATE_PROFILE_TAIL)}
      </div>
    </PublicCard>

    <PublicCard title="Our Business Activity" icon="bi-diagram-3">
      <div className="page-prose">
        {paras(BUSINESS_ACTIVITY_INTRO)}
        {bullets(BUSINESS_ACTIVITY_POINTS)}
        {paras(BUSINESS_ACTIVITY_TAIL)}
      </div>
    </PublicCard>

    <PublicCard title="Facilon Mission & Vision" icon="bi-compass">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="border border-slate-200 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <img src="/assets/images/site/about-us-1.png" alt="" width={32} height={32} />
            <h3 className="font-bold text-[#052f55] text-sm m-0">Our Mission</h3>
          </div>
          <div className="page-prose">
            <p>{MISSION}</p>
          </div>
        </div>
        <div className="border border-slate-200 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <img src="/assets/images/site/about-us-2.png" alt="" width={32} height={32} />
            <h3 className="font-bold text-[#052f55] text-sm m-0">Our Vision</h3>
          </div>
          <div className="page-prose">
            <p>{VISION}</p>
          </div>
        </div>
      </div>
    </PublicCard>

    <PublicCard title="Our Products and Solutions" icon="bi-box-seam">
      <div className="page-prose">
        {paras(PRODUCTS_INTRO)}
        {bullets(PRODUCTS_POINTS)}
        <p>{PRODUCTS_TAIL}</p>
      </div>
    </PublicCard>

    <PublicCard title="Our Board of Directors" icon="bi-people-fill">
      <div className="page-prose mb-4">
        <p>{BOARD_INTRO}</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {BOARD_MEMBERS.map((member) => (
          <div key={member.name} className="border border-slate-200 rounded-lg p-4">
            <h3 className="font-bold text-[#052f55] text-sm m-0">{member.name}</h3>
            <p className="text-[#be1717] text-[0.7rem] font-semibold uppercase tracking-wide mt-0.5 mb-2">
              {member.role}
            </p>
            <ul className="text-[0.8rem] leading-relaxed text-slate-600 pl-4 m-0 space-y-1">
              {member.highlights.map((h) => (
                <li key={h}>{h}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </PublicCard>
  </PublicPage>
);

export default AboutUs;
